import { Suspense, Fragment, lazy, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./Layout/AdminLayout";
import { Fallback } from "./Layout/Fallback";

const adminRoutes = [
  {
    exact: true,
    path: "/admin/login",
    element: lazy(() => import("./components/admin/login/Index")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/dashboard",
    element: lazy(() => import("./components/admin/dashboard/Index")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/customers",
    element: lazy(() => import("./components/admin/customers/CustomersList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/customers/:id",
    element: lazy(() => import("./components/admin/customers/CustomersList")),
  },
  // Shipper Routes
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shippers",
    element: lazy(() => import("./components/admin/shipper/ShippersList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shippers/:id",
    element: lazy(() => import("./components/admin/shipper/ShippersList")),
  }, , ,
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shippers/:shipperId/drivers",
    element: lazy(() => import("./components/admin/driver/DriverList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shippers/:shipperId/drivers/:driverId",
    element: lazy(() => import("./components/admin/driver/DriverList")), // Same component - modal will open
  },

  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shippers/:shipperId/fleet",
    element: lazy(() => import("./components/admin/fleet/FleetList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shippers/:shipperId/fleet/:fleetId",
    element: lazy(() => import("./components/admin/fleet/FleetList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/vehicle-types",
    element: lazy(() => import("./components/admin/manageFleets/VehicleTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/vehicle-types/:id",
    element: lazy(() => import("./components/admin/manageFleets/VehicleTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/vehicle-makes",
    element: lazy(() => import("./components/admin/manageFleets/VehicleMakeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/vehicle-makes/:id",
    element: lazy(() => import("./components/admin/manageFleets/VehicleMakeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/cargo-types",
    element: lazy(() => import("./components/admin/manageFleets/CargoTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/cargo-types/:id",
    element: lazy(() => import("./components/admin/manageFleets/CargoTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/business-types",
    element: lazy(() => import("./components/admin/manageFleets/BusinessTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/business-types/:id",
    element: lazy(() => import("./components/admin/manageFleets/BusinessTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shipments",
    element: lazy(() => import("./components/admin/shipments/ShipmentList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/shipments-pending",
    element: lazy(() => import("./components/admin/shipments/PendingAssignmentShipments")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/license-types",
    element: lazy(() => import("./components/admin/manageFleets/LicenseTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/fleet/license-types/:id",
    element: lazy(() => import("./components/admin/manageFleets/LicenseTypeList")),
  },
  {
    layout: AdminLayout,
    exact: true,
    path: "/admin/payments",
    element: lazy(() => import("./components/admin/payments/PaymentsList")),
  },
];

function AdminApp() {

  return (
    <Suspense fallback={<Fallback />}>
      <Routes>
        {adminRoutes.map((route, i) => {
          const Guard = route?.guard || Fragment;
          const Auth = route?.auth || Fragment;
          const Layout = route?.layout || Fragment;
          const Component = route.element;
          return (
            <Route
              key={i}
              path={route.path}
              element={
                <Guard>
                  <Auth>
                    <Layout>
                      <Component />
                    </Layout>
                  </Auth>
                </Guard>
              }
            />
          );
        })}
        <Route path="/admin/*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </Suspense>
  );
}

export default AdminApp;